import type { PrizeUiStatus } from '../constants/status'

export const getPrizeParticipationHint = (
  uiStatus: PrizeUiStatus,
  ineligibilityHint?: string | null
): string | null => {
  if (uiStatus === 'progress') return 'Você está participando'
  if (uiStatus === 'available') return 'Participe gratuitamente'
  if (uiStatus === 'locked' && ineligibilityHint) return ineligibilityHint
  if (uiStatus === 'expired') return 'Encerrado'
  if (uiStatus === 'success') return 'Parabéns! Você ganhou este concurso.'

  return null
}
